module.exports = __webpack_public_path__ + "static/media/arrow_left_circle.77a1b8be.png";